export const absencePlannerBodyClasses = {
  virtualizedContentContainer: {
    width: 'fit-content',
    display: 'flex',
  },
  lastRow: {
    flex: 1,
  },
}
